import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavigationBars from '../../components/HOC/withNavigationBars';
import { Loader, Breadcrumbs } from 'kangarootime-ui';
import { Grow, Modal } from '@material-ui/core';
import RaisedContainer from '../../components/RaisedContainer';
import actions from './duck/actions';
import moment from 'moment';
import MonthYearPhotoGrid from './MonthYearPhotoGrid';
import RoomFilter from '../../components/RoomFilter';

class CenterGallery extends Component {
  constructor (props) {
    super(props);

    this.state = {
      date: moment(),
      showLightbox: false,
      selectedPhoto: null,
      filteredClassroomId: 'all'
    };

    this.scrollerRef = React.createRef();
  }

  get breadcrumbs () {
    return [
      { label: 'Dashboard', link: null },
      { label: `${this.props.currentCenterName}'s Gallery`, link: null }
    ];
  }

  componentDidMount = () => {
    const currentMonth = this.state.date.month();
    const currentYear = this.state.date.year();

    this.props.getPhotosForMonth(currentMonth, currentYear);
  }

  handleScroll = event => {
    event.preventDefault();

    const endOfList = event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight);

    // hit the end of the list and aren't already fetching more photos
    if (endOfList && !this.props.fetchingPhotosForMonth) {
      this.loadPreviousMonth();
    }
  }

  /**
   * use the date stored in state to fetch photos for the previous month
   */
  loadPreviousMonth = () => {
    const dateClone = this.state.date.clone();
    const previous = dateClone.subtract(1, 'month');
    const previousMonth = previous.month();
    const previousMonthYear = previous.year();

    this.props.getPhotosForMonth(previousMonth, previousMonthYear);

    this.setState({ date: previous });
  }

  /**
   * determine which photos to show based on the classroon filter
   */
  photosToShow = () => {
    const { filteredClassroomId } = this.state;
    let byMonthCopy = { ...this.props.photosByMonth };

    // <RoomFilter /> 'All' option has a value of 'all
    if (!filteredClassroomId || filteredClassroomId === 'all') {
      return this.props.photosByMonth;
    }

    // return photos.filter(photo => photo.room_id === filteredClassroom);
    Object.keys(byMonthCopy).forEach(key => {
      const photosForMonth = byMonthCopy[key];

      byMonthCopy[key] = photosForMonth.filter(photo => photo.room_id === filteredClassroomId);
    });

    return byMonthCopy;
  }

  dismissLightbox = () => this.setState({ showLightbox: false, selectedPhoto: null });

  render () {
    return (
      <NavigationBars>
        <Loader loading={this.showLoader}>
          <div className='flex-columns flex-1'>
            <Breadcrumbs breadcrumbs={this.breadcrumbs} />
            <RaisedContainer style={{ height: '80vh' }}>
              <div style={{ margin: '8px 16px', position: 'sticky' }}>
                <RoomFilter
                  rooms={this.props.rooms}
                  onSelect={event => this.setState({ filteredClassroomId: event.target.value })}
                  selected={this.state.filteredClassroomId}
                />
              </div>
              <MonthYearPhotoGrid
                fetchingMore={this.props.fetchingPhotosForMonth}
                photosByMonth={this.photosToShow()}
                loadMorePhotos={this.loadPreviousMonth}
                selectPhoto={selectedPhoto => this.setState({ showLightbox: true, selectedPhoto })}
                onScroll={this.handleScroll}
              />
            </RaisedContainer>
          </div>
          { this.state.selectedPhoto &&
            <Modal open={this.state.showLightbox} onClose={this.dismissLightbox}>
              <Grow in>
                <div className='flex-columns' style={{ justifyContent: 'center', margin: 32, height: '90vh' }}>
                  <img
                    alt='attachment'
                    src={this.state.selectedPhoto.url}
                    style={{ minHeight: '100%', objectFit: 'contain' }}
                    onClick={this.dismissLightbox}
                  />
                </div>
              </Grow>
            </Modal>
          }
        </Loader>
      </NavigationBars>
    );
  }
}

function mapStateToProps (state) {
  return {
    photosByMonth: state.gallery.byMonth.photos,
    fetchingPhotosForMonth: state.gallery.byMonth.fetchingPhotosForMonth,
    currentCenterName: state.identity.centers.filter(center => parseInt(center.id, 10) === parseInt(state.identity.centerId, 10))[0].name || '',
    rooms: state.rooms.rooms.filter(room => room.name !== 'Floats')
  };
}

function mapDispatchToProps (dispatch) {
  return {
    getPhotosForMonth: (month, year) => dispatch(actions.getPhotosForMonthRequest(month, year))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CenterGallery);
